import { KeyValue } from '@api/api/entity-report';
import { WithNAFallback } from '@design/components/table';
import { TooltipContainer } from '@terminal/components/tooltip-container/TooltipContainer';
import clsx from 'clsx';

import styles from './KeyValueElement.module.scss';

export interface KeyValueElementProps {
  keyValue: KeyValue;
  isDefaultVariant?: boolean;
  tooltip?: string;
}

export const KeyValueElement = ({
  keyValue,
  tooltip,
  isDefaultVariant = true,
}: KeyValueElementProps) => {
  return (
    <div
      className={clsx(styles.keyValueElementRoot, {
        [styles.defaultVariant]: isDefaultVariant,
      })}
      data-testid="components"
    >
      <TooltipContainer label={tooltip} showUnderline>
        <div className={styles.title} tabIndex={tooltip ? 0 : undefined}>
          {keyValue.display}
        </div>
      </TooltipContainer>
      <div className={styles.details}>
        <span className={styles.value}>
          <WithNAFallback
            check={keyValue.value_fmt !== undefined}
            value={keyValue.value_fmt}
          />
        </span>
        {keyValue.value_fmt && (
          <span className={styles.unit}>{keyValue.unit}</span>
        )}
      </div>
    </div>
  );
};
